/* ================================================
   The Pets Store — Auto-add Guida PDF quando
   il cliente aggiunge il GPS SafePet G12
   ================================================ */

(function() {
  const GPS_VARIANT_ID  = 51203806986581;
  const GIFT_VARIANT_ID = 51453956817237;

  // Aspetta che il DOM sia pronto
  document.addEventListener('DOMContentLoaded', init);

  function init() {
    // Intercetta tutti i form "Aggiungi al carrello" nella pagina
    document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
      form.addEventListener('submit', handleAddToCart);
    });

    // Intercetta anche i click sui pulsanti buy-now / quick-add
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('[data-product-id], .quick-add__submit, .product-form__submit');
      if (btn) {
        setTimeout(checkAndAddGift, 800);
      }
    });

    // Intercetta le chiamate fetch al cart/add (per drawer cart e quick-add)
    interceptFetch();
  }

  function interceptFetch() {
    const originalFetch = window.fetch;
    window.fetch = function(url, options) {
      const result = originalFetch.apply(this, arguments);

      if (typeof url === 'string' && url.includes('/cart/add')) {
        result.then(function(response) {
          // Clone per non consumare il body
          response.clone().json().then(function(data) {
            const items = data.items || (data.id ? [data] : []);
            const hasGPS = items.some(function(item) {
              return item.variant_id === GPS_VARIANT_ID || item.id === GPS_VARIANT_ID;
            });
            if (hasGPS) {
              setTimeout(addGiftToCart, 400);
            }
          }).catch(function() {});
        }).catch(function() {});
      }

      return result;
    };
  }

  function handleAddToCart(e) {
    const form = e.target;
    const variantInput = form.querySelector('[name="id"]');
    if (variantInput && parseInt(variantInput.value) === GPS_VARIANT_ID) {
      setTimeout(addGiftToCart, 600);
    }
  }

  function checkAndAddGift() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        const hasGPS = cart.items.some(function(item) {
          return item.variant_id === GPS_VARIANT_ID;
        });
        if (hasGPS) {
          addGiftToCart();
        }
      })
      .catch(function() {});
  }

  function addGiftToCart() {
    // Prima controlla che il GPS sia nel carrello e la guida non ci sia già
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        const hasGPS  = cart.items.some(function(i) { return i.variant_id === GPS_VARIANT_ID; });
        const hasGift = cart.items.some(function(i) { return i.variant_id === GIFT_VARIANT_ID; });

        if (hasGPS && !hasGift) {
          // Aggiunge la guida con proprietà che la identifica come omaggio
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: GIFT_VARIANT_ID,
                quantity: 1,
                properties: {
                  '_gift': 'true',
                  'Omaggio': '🎁 Incluso con SafePet™ G12'
                }
              }]
            })
          });
        } else if (!hasGPS && hasGift) {
          // Se il GPS viene rimosso, rimuove anche la guida
          return removeGiftFromCart();
        }
      })
      .then(function() {
        // Aggiorna il drawer del carrello se aperto
        refreshCart();
      })
      .catch(function() {});
  }

  function removeGiftFromCart() {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: GIFT_VARIANT_ID,
        quantity: 0
      })
    });
  }

  function refreshCart() {
    // Aggiorna il drawer Shopify Dawn se disponibile
    if (typeof window.Shopify !== 'undefined') {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
    // Aggiorna il contatore nel header
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble) {
          const count = bubble.querySelector('.cart-count-bubble span');
          if (count) count.textContent = cart.item_count;
        }
        // Forza reload del drawer cart di Dawn
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(c) {
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: c }));
            });
        }
        // Se il carrello e' un drawer Dawn, usa il metodo nativo
        if (window.CartDrawer) {
          const drawer = document.querySelector('cart-drawer');
          if (drawer) drawer.open();
        }
      });
  }

  // Monitora anche la rimozione di prodotti dal carrello
  document.addEventListener('click', function(e) {
    const removeBtn = e.target.closest('.cart-remove-button, [data-action="remove-item"], .cart__remove');
    if (removeBtn) {
      setTimeout(function() {
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            const hasGPS  = cart.items.some(function(i) { return i.variant_id === GPS_VARIANT_ID; });
            const hasGift = cart.items.some(function(i) { return i.variant_id === GIFT_VARIANT_ID; });
            if (!hasGPS && hasGift) {
              removeGiftFromCart().then(refreshCart);
            }
          });
      }, 500);
    }
  });

})();
